import getWithToken from './base/get-with-token'

const getAlerts = getWithToken(`/alerts`)

export default getAlerts
